import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import VoteArrow from '../vote-arrow/vote-arrow';

import QUESTION_QUERY from '../../queries/question-query';
import COMMUNITY_QUESTIONS_QUERY from '../../queries/community-questions-query';

const mappedRefetchQueries = {
  QUESTION_QUERY,
  COMMUNITY_QUESTIONS_QUERY
};

import './vote-buttons.scss';

const COMMUNITY_VOTE_MUTATION = gql`
  mutation COMMUNITY_VOTE_MUTATION(
      $upOrDown: String!,
      $referenceId: ID!
      $voteOnWhat: String!
    ) {
      communityVote(
        upOrDown: $upOrDown,
        referenceId: $referenceId,
        voteOnWhat: $voteOnWhat
      ) {
        success
      }
    }
`;

class VoteButtons extends PureComponent {
  constructor(props) {
    super();
    const ratedUp = props.ratedUpKnowledgeItems.filter(item => item.createdBy.id === props.myId).length > 0;
    const ratedDown = props.ratedDownKnowledgeItems.filter(item => item.createdBy.id === props.myId).length > 0;

    let votedByUser = '';
    if (ratedUp) {
      votedByUser = 'up';
    }
    if (ratedDown) {
      votedByUser = 'down';
    }
    this.state = {
      votedByUser
    };
  }

  performVote = (votedByUser, submit) => {
    // first check if logged in
    if (!this.props.myId) return this.props.toggleOverlay();
    if (this.props.posterId === this.props.myId) return alert('You can not vote on your own posts');
    const newVotedByUserState = this.state.votedByUser === votedByUser ? '' : votedByUser;
    this.setState({
      votedByUser: newVotedByUserState
    }, () => {
      submit();
    })
  };

  render() {
    const {
      ratedDownKnowledgeItems,
      ratedUpKnowledgeItems,
      myId,
      voteOnWhat,
      referenceId,
      refetchQueryName,
      refetchQueryVariables,
      disabled
    } = this.props;

    const { votedByUser } = this.state;

    let loggedInUserRating;
    switch(votedByUser) {
      case 'up':
        loggedInUserRating = 1;
        break;
      case 'down':
        loggedInUserRating = -1;
        break;        
      default: 
        loggedInUserRating = 0;
    }
    const rating = ratedUpKnowledgeItems.filter(item => item.createdBy.id !== myId).length - ratedDownKnowledgeItems.filter(item => item.createdBy.id !== myId).length + loggedInUserRating;

    return (
      <Mutation
        mutation={COMMUNITY_VOTE_MUTATION}
        variables={{
          referenceId,
          upOrDown: votedByUser,
          voteOnWhat
        }}
        refetchQueries={[{
          query: mappedRefetchQueries[refetchQueryName],
          variables: refetchQueryVariables
        }]}
      >
        {(submit, { error, loading }) => {
          return (
            <div className="vote-buttons">
              <div className="vote-buttons__inner">
                <div className="vote-buttons__vote vote-buttons__vote--up-vote">
                  <VoteArrow
                    voteAction={upOrDown => this.performVote(upOrDown, submit)}
                    type="up"
                    helpText="Vote up"
                    active={votedByUser === 'up'}
                    disabled={loading || disabled}
                  />
                </div>
                <div className="vote-buttons__current-vote">{rating}</div>
                <div className="vote-buttons__vote vote-buttons__vote--down-vote">
                  <VoteArrow
                    voteAction={upOrDown => this.performVote(upOrDown, submit)}
                    type="down"
                    helpText="Vote down"
                    active={votedByUser === 'down'}
                    disabled={loading || disabled}
                  />
                </div>
              </div>
            </div>
          )
        }}
      </Mutation>
    );
  }
}

VoteButtons.propTypes = {

};

export default VoteButtons;